import React from 'react';
import firebase from 'firebase';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import './SignInOptions.css';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as ROUTES from '../../constants/routes';
import { useHistory, useLocation } from 'react-router';
import PhoneIcon from '@material-ui/icons/Phone';
import { useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { set } from 'lodash';
import { connect } from 'react-redux';
import { signInSuccess } from '../../redux/signIn/actions';
import { getUserType } from '../../api/SignIn/signIn.api';
import { getProfile } from '../../redux/profile/action';
import CustomAlerts from '../alerts/CustomAlerts';

function SignInOptions({ check, signInSuccess, getProfile }) {
	const history = useHistory();
	const [show, setShow] = useState(false);
	const [formData, setFormData] = useState({
		fullname: '',
	});
	const [snackbar, setSnackbar] = useState(false);
	const [error, setError] = useState('');

	const [phoneNumber, setPhoneNumber] = useState();

	const { fullname } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	var uiConfig = {
		signInFlow: 'popup',
		signInOptions: [
			{
				provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
				fullLabel: 'Sign In With Google',
				disableSignUp: true,
			},
			// {
			// 	provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
			// 	fullLabel: 'Sign In With Facebook',
			// 	disableSignUp: true,
			// },
		],

		callbacks: {
			beforeSignInSuccess: () => {
				return false;
			},
			signInSuccessWithAuthResult: async (authResult) => {
				console.log('authResult ', authResult);
				let currentUserType = await getUserType();
				await getProfile();

				signInSuccess({
					userInfo: {
						displayName: authResult.user.displayName,
						email: authResult.user.email,
						phoneNumber: authResult.user.phoneNumber,
						photoURL: authResult.user.photoURL,
						uid: authResult.user.uid,
					},
					userType: currentUserType,
				});

				return false;
			},
		},
	};

	const handleSignIn = (e) => {
		e.preventDefault();
		if (check === false) {
			setError('You have to accept the terms and conditions.');
			setSnackbar(true);
			setTimeout(() => {
				setError('');
			}, 4000);
		} else if (phoneNumber === '') {
			setError('Please fill in all the fields');
			setSnackbar(true);
			setTimeout(() => {
				setError('');
			}, 4000);
		} else {
			var recaptcha = new firebase.auth.RecaptchaVerifier('recaptcha');

			firebase
				.auth()
				.signInWithPhoneNumber(phoneNumber, recaptcha)
				.then((confirmationResult) => {
					console.log('recaptchaa', recaptcha);
					var code = prompt(
						'Enter code send to your phone number: ',
						''
					);

					if (code === null) return;

					confirmationResult.confirm(code).then((result) => {
						console.log('result.user', result.user);

						history.push('/');
					});
				})
				.catch(function (error) {
					console.error(error);
					setError(error.message);
					setSnackbar(true);
					setTimeout(() => {
						setError('');
					}, 4000);
				});
		}
	};

	const useStyles = makeStyles({
		root: {
			marginLeft: '0px',
		},
	});

	const styles = useStyles();

	return (
		<div className='signinoptions'>
			{error && (
				<CustomAlerts
					alertType='error'
					alertMsg={error}
					snackbar={snackbar}
					setSnackbar={setSnackbar}
				/>
			)}
			<StyledFirebaseAuth
				uiConfig={uiConfig}
				firebaseAuth={firebase.auth()}
			/>
			{/* {show ? (
				<div className='phone_signup_container'>
					<form
						className='form formPhoneNumber'
						noValidate
						autoComplete='off'
					>
						<div className='form-group'>
							<PhoneInput
								placeholder='Enter phone number'
								value={phoneNumber}
								onChange={setPhoneNumber}
								defaultCountry='CA'
							/>
						</div>
						<div className='phone_control'>
							<div className='phone_cancel_btn'>
								<button
									className='phonebtn'
									onClick={() => setShow(false)}
								>
									Cancel
								</button>
							</div>
							<div className='phone_register'>
								<button
									type='submit'
									className='registerbtn'
									onClick={handleSignIn}
								>
									Sign In
								</button>
							</div>
						</div>
						<div id='recaptcha'></div>
					</form>
				</div>
			) : (
				<div className='phone_signup_container'>
					<button className='phoneBtn' onClick={() => setShow(true)}>
						<PhoneIcon className='phoneIcon' />
						<span>Sign In with Phone Number</span>
					</button>
				</div>
			)} */}
		</div>
	);
}

export default connect(null, { signInSuccess, getProfile })(SignInOptions);
